import templateUrl from './editDayPart.html';

export default {
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "settings" */ './editDayPartComponentCtrl')).default,
  controllerAs: 'ctrl',
  bindings: {
    dayPart: '=',
    onSubmit: '&',
    dismiss: '&',
  },
  templateUrl,
};
